import styled from 'styled-components';
import { Text14Light, Text18Bold } from '../utils/Text/Text.styles';

export const UploadFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  height: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  position: relative;
  border-radius: 16px;
  border: 1px dashed #e5e7eb;
  background-color: white;
`;

export const UploadText = styled(Text18Bold)`
  text-decoration: underline;
  color: #1672ba;
`;

export const Text = styled(Text14Light)`
  opacity: 0.56;
  text-align: center;
`;
